export const GET_ABHA_TOKEN_LIST = (clinic_id) =>
  `abha/v1/${clinic_id}/get-tokens`;
export const GET_PATIENT_ACCOUNT_LIST = (clinic_id) =>
  `/abha/v1/${clinic_id}/list-patient-records`;
export const UPDATE_PATIENT_DETAILS_WITH_ABHA = `abha/v1/patient-demographic-update`;
export const GET_STATE = "/public/get-city";
